/**
 * @file experienceList.component.tsx
 * @path apps/website/src/features/experiences/components/experienceList.component.tsx
 */
import { ExperienceSummary } from "../experience.types";
import { ExperienceCard } from "./experienceCard.component";

interface ExperienceListProps {
  items: ExperienceSummary[];
  onReset: () => void;
}

export const ExperienceList = ({ items, onReset }: ExperienceListProps) => {
  if (items.length === 0) {
    return (
      <div className="py-20 text-center border border-dashed border-border rounded-xl">
        <p className="text-muted-foreground font-open-sans">
          No experiences found matching your criteria.
        </p>
        <button
          onClick={onReset}
          className="mt-4 text-accent uppercase text-xs tracking-widest hover:underline"
        >
          Reset All Filters
        </button>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-10">
      {items.map((item, index) => (
        <ExperienceCard key={item.id} item={item} index={index} />
      ))}
    </div>
  );
};
